import React from 'react';
import { t, Trans } from '@lingui/macro';
import { Alert, AlertIcon, Heading, Stack } from '@cardboard-ui/react';
import { graphql, useFragment } from 'utils/graphClient';
import { UserHandle } from 'components/UserHandle';
import { useI18n } from 'utils/i18n';
import { VaultItemAccessDetails_node$key } from './__generated__/VaultItemAccessDetails_node.graphql';

const fragment = graphql`
  fragment VaultItemAccessDetails_node on VaultItem {
    id
    uploadGroup {
      publisher {
        id
        ...UserHandle_member
      }
      publishedAt {
        utcDate
        utcTime
      }
    }
  }
`;

interface VaultItemAccessDetailsProps {
  node: VaultItemAccessDetails_node$key;
}

export function VaultItemAccessDetails({ node }: VaultItemAccessDetailsProps) {
  const { uploadGroup } = useFragment(fragment, node);
  const { format } = useI18n();
  const { publisher, publishedAt } = uploadGroup;
  const localisedDateAndTime = publishedAt
    ? format(new Date(`${publishedAt.utcDate}T${publishedAt.utcTime}Z`), 'PPPp')
    : '';

  return (
    <Stack spacing={4}>
      <Stack>
        <Heading size="sm">{t`Published by`}</Heading>
        <UserHandle
          member={publisher}
          showAvatar
          avatarProps={{ size: 'sm' }}
        />
      </Stack>
      <Stack>
        <Trans>
          <Heading size="sm">Published on</Heading>
          <i>{localisedDateAndTime}</i>
        </Trans>
      </Stack>
      <Stack>
        <Heading size="sm">{t`Advanced stats`}</Heading>
        <Alert status="info" borderRadius="md">
          <AlertIcon />
          {t`Advanced information on who has viewed this file and when will be available in the future`}
        </Alert>
      </Stack>
    </Stack>
  );
}
